import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {PostElectronicBill} from 'domain/usecases/private/my-payments-flow/post-set-electronic-bill';
import {PostElectronicBillResponse} from 'domain/usecases/private/my-payments-flow/post-set-electronic-bill/types';

export class RemotePostElectronicBill implements PostElectronicBill {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostElectronicBillResponse>,
	) {}

	async post(): Promise<PostElectronicBillResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			responseType: 'json',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
